import { useQuery } from 'react-query';
import { Customer } from '../../../interfaces/customer.interface';
import { apiRQ } from '../../api';

const getCustomer = async (id: string | undefined): Promise<Customer> => {
  const resp = await apiRQ.get<Customer>(`/customers/${id}`);

  return resp.data;
};

export const useCustomer = (id: string | undefined) => {
  return useQuery<Customer, Error>(['getCustomer', id], () => getCustomer(id), {
    enabled: !!id,
    cacheTime: 500,
    staleTime: 500,
    refetchOnWindowFocus: false,
  });
};
